<template>
  <div class="vjs-annotation" v-if="annotations?.length">
    <a v-for="(item, id) in annotationsToDisplay" :key="id" :style="item[1].style" class="annotation" target="_blank"
      :href="absoluteLink(item[1].href)">{{ item[1].href }}</a>
  </div>
  <div v-else>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "interacitive-annotation",
  components: {},
  props: {
    player: {
      required: true,
      type: Object,
    },
  },
  computed: {
    annotations() {
      return this.setVideoInfos?.interactivityOptions?.data?.annotations
    },
    ...mapGetters(['setVideoInfos'])
  },
  data() {
    return {
      annotationsToDisplay: new Map(),
      videoWrapperStyle: {},
    };
  },
  watch: {
    player: {
      handler() {
        this.player.on("timeupdate", () => {
          const currentTime = Math.round(this.player.currentTime());
          const viWidth = this._getFloatStyle(this.videoWrapperStyle.width);
          const viHeight = this._getFloatStyle(this.videoWrapperStyle.height);
          this.annotations?.forEach((item) => {
            let end = item.duration + item.start;
            if (
              Math.round(currentTime) < end &&
              Math.round(currentTime) >= item.start
            ) {
              if (!this.annotationsToDisplay.has(item.id)) {
                let actualTopValue = 0;
                if (this._getFloatStyle(this.videoWrapperStyle.top) != 0) {
                  actualTopValue =
                    this._getFloatStyle(this.videoWrapperStyle.top) -
                    viHeight / 2;
                }

                item.style = {
                  width: "auto",
                  height: "auto",
                  top:
                    actualTopValue + (+item.position_y * viHeight) / 100 + "px",
                  left:
                    this._getFloatStyle(this.videoWrapperStyle.left) +
                    (+item.position_x * viWidth) / 100 +
                    "px",
                };
                this.annotationsToDisplay.set(item.id, item);
              }
            } else {
              this.annotationsToDisplay.delete(item.id);
              this.annotationsToDisplay.clear();
            }
          });

        });
      },
      deep: true
    },
  },
  mounted() {
    this.updateAnnotationsPosition();
    window.addEventListener("resize", () => {
      this.updateAnnotationsPosition();
    });
  },
  methods: {
    updateAnnotationsPosition() {
      const videoElStyle = window.getComputedStyle(
        document.querySelector(".vjs-tech")
      );
      setTimeout(() => {
        this.videoWrapperStyle = videoElStyle;
      }, 500);
    },
    _getFloatStyle(style) {
      return +style?.substring(0, style.length - 2);
    },
    absoluteLink(link) {
      if (link.includes("https")) {
        return link;
      } else {
        return `https://${link}`;
      }
    },
  },
});
</script>

<style>
.annotation {
  position: absolute;
  background: var(--vm-color-three-06) ;
  color: var(--vm-color-one-08) ;
  padding: 0.5em;
  text-decoration: none;
  border-radius: 4px;
}

.annotation:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 1000px) {
  .annotation {
    font-size: 1vw;
  }
}
</style>
